export default "__VITE_ASSET__2b490ccd__"